import React, { useState, useContext, useEffect } from 'react';
import { getToken, getLikes, saveLike } from "../../../services/social.services";
import GlobalContext from "../../../contexts/globalContext";
import "./like-button.scss";
import ModalGuiaCdc from '../../molecules/modal-guia-cdc/modalGuiaCdc';

const LikeButton = (props:any) => {

  const Context = useContext(GlobalContext);
  const [readOnly, setReadOnly] = useState(false);
  const [likedByUserLocal, setLikedByUserLocal] = useState(false);
  const [likeCountLocal, setLikeCountLocal] = useState(0);
  const [likeTypeByUser, setLikeTypeByUser] = useState(-1);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const getLikesData = async () => {
    if (props.contentId) {
      const email = Context.gigyaContext.gigyaAccount ? Context.gigyaContext.gigyaAccount.profile.email : null;
      const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
      const response = await getLikes(props.contentId, props.contentType, email, token);
      setLikeTypeByUser(response.data.data.likeTypeByUser);
      setLikedByUserLocal(response.data.data.likedByUser);
      setLikeCountLocal(response.data.data.likesTotales);
    }
  };

  const saveLikeData = async (contentId, contentType, removeLike, likeType) => {
      const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
      const data:any = {
          "usuarioDoc": Context.gigyaContext.gigyaAccount?.data.docNumber,
          "usuarioEmail": Context.gigyaContext.gigyaAccount!.profile.email,
          "usuarioNombre": Context.gigyaContext.gigyaAccount!.profile.firstName + " " + Context.gigyaContext.gigyaAccount!.profile.lastName,
          "usuarioFoto": Context.gigyaContext.gigyaAccount?.profile.photoURL,
          "contenidoId": contentId,
          "contenidoTipo": contentType,
          "likeType": likeType,
          "remove": removeLike
      };
      const newData = await saveLike(data, token);
      setLikedByUserLocal(newData.data.data.likedByUser);
      setLikeCountLocal(newData.data.data.likesTotales);
  }

  const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

  const handleLikeClick = (likeType) => {
    if (!Context.gigyaContext.gigyaAccount) {
      const checkGuideCdc = localStorage.getItem("guideCdc");
      if (checkGuideCdc !== "true"){
          setIsOpenModal(true);
      } else {
          Context.gigyaContext.loginComfamaId!();
      }
    }
    else {
      saveLikeData(props.contentId, props.contentType, likeType == -1, likeType);
    }
  }

  useEffect(() => {
      setReadOnly(!!props.readOnly);
  }, []);

  useEffect(() => {
      if (Context.gigyaContext.gigyaAccount) getLikesData();
  }, [Context.gigyaContext.gigyaAccount]);

  const zeroLikesMessage = "Mira el contenido y dale 'Me gusta'";

  const RenderedCmp = () => {
    if (readOnly) {
      return (
        <div className="likes-neutral">
          <i className="icon-thumbs-up1" />
          <span className="likes-texto-btn">
            {likeCountLocal == 0 ?
              zeroLikesMessage
            :
              `A ${likeCountLocal} persona${likeCountLocal > 1 ? "s " : " "} le${likeCountLocal > 1 ? "s " : " "} gusta esto`
            }
          </span>
        </div>
      );
    }
    else if (props.soloContador) {
      return (
        <div className={`likes-${likedByUserLocal ? "user" : "neutral"}`}>
          <button onClick={()=> handleLikeClick(likedByUserLocal && likeTypeByUser == 1 ? -1 : 1)}>
              <i className="icon-thumbs-up1" />
              <span>
                {likeCountLocal}
              </span>
              {props.textoBoton && <span className="likes-texto-btn">{props.textoBoton}</span>}
          </button>
        </div>
      );
    }
    else {
      return  (
        <div className={`likes-desc-${likedByUserLocal ? "user" : "neutral"}`}>
          <button onClick={()=> handleLikeClick(likedByUserLocal && likeTypeByUser == 1 ? -1 : 1)}>
            <i className="icon-thumbs-up1" />
            <span className="likes-texto-btn">
              {likeCountLocal == 0 ? zeroLikesMessage :
              likedByUserLocal && likeCountLocal == 1 ?
                  "Te gusta esto"
                  :
                  `A ${likedByUserLocal? " ti y a " : ""} ${likedByUserLocal && likeCountLocal > 1 ?
                          likeCountLocal - 1 :
                          likeCountLocal} persona${likedByUserLocal && likeCountLocal == 2 ?
                          "" :
                          likeCountLocal > 1 ? "s " : " "} le${likeCountLocal > 1 ? "s " : " "} gusta esto`}
            </span>
          </button>
        </div>
      );
    }
  }

  return (
      <>
        <RenderedCmp/>
        {isOpenModal && (
            <ModalGuiaCdc showModal={isOpenModal} onClose={closeModal}/>
        )}
      </>
  );

}

export default LikeButton;